import { render, staticRenderFns } from "./matou.vue?vue&type=template&id=590bb500&scoped=true"
import script from "./matou.vue?vue&type=script&lang=js"
export * from "./matou.vue?vue&type=script&lang=js"
import style0 from "./matou.vue?vue&type=style&index=0&id=590bb500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bb500",
  null
  
)

export default component.exports